import AmbireLogoSquare from './AmbireLogoSquare'

export default AmbireLogoSquare
